(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const copyButtons = document.querySelectorAll('.blog-post-sharing__link--copy');
    
    copyButtons.forEach(button => {
      button.addEventListener('click', function() {
        const url = this.getAttribute('data-copy-url');
        const feedback = this.querySelector('.blog-post-sharing__copy-feedback');
        
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(() => {
            if (feedback) {
              feedback.textContent = 'Link kopiert!';
              feedback.classList.add('show');
              setTimeout(() => {
                feedback.classList.remove('show');
              }, 2000);
            }
          }).catch(() => {
            fallbackCopy(url, feedback);
          });
        } else {
          fallbackCopy(url, feedback);
        }
      });
    });
    
    function fallbackCopy(text, feedback) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      
      try {
        document.execCommand('copy');
        if (feedback) {
          feedback.textContent = 'Link kopiert!';
          feedback.classList.add('show');
          setTimeout(() => {
            feedback.classList.remove('show');
          }, 2000);
        }
      } catch (err) {
        if (feedback) {
          feedback.textContent = 'Fehler beim Kopieren';
          feedback.classList.add('show');
          setTimeout(() => {
            feedback.classList.remove('show');
          }, 2000);
        }
      }
      
      document.body.removeChild(textArea);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
